(function() {
  function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
      get: v,
      set: s,
      enumerable: true,
      configurable: true
    });
  }
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("ezkA5", function(module, exports) {
    $parcel$export(module.exports, "onTagalysReady", function() {
      return $a9b44c853f7ad42f$export$8029fffc6aa71bf9;
    });
    $parcel$export(module.exports, "createProductCardHTML", function() {
      return $a9b44c853f7ad42f$export$7215210a376abae6;
    });
    var $cJzMp = parcelRequire("cJzMp");
    var $65zHg = parcelRequire("65zHg");
    const $a9b44c853f7ad42f$var$log = (0, $cJzMp.createLogger)("tagalys-helpers");
    function $a9b44c853f7ad42f$export$8029fffc6aa71bf9(callback, options = {}) {
      const {timeout: timeout = 5e3, interval: interval = 50} = options;
      $a9b44c853f7ad42f$var$log("lifecycle", "Waiting for Tagalys readiness", {
        hasWindowHook: typeof window !== "undefined" && Boolean(window.onTagalysReady),
        hasTagalys: typeof window !== "undefined" && Boolean(window.Tagalys),
        hasAPIConnector: typeof window !== "undefined" && Boolean(window.Tagalys?.APIConnector),
        hasConfig: typeof window !== "undefined" && Boolean(window.tagalysConfig),
        timeout: timeout,
        interval: interval
      });
      if (window.onTagalysReady) {
        $a9b44c853f7ad42f$var$log("lifecycle", "Using window.onTagalysReady hook");
        window.onTagalysReady(callback);
        return;
      }
      const hasTagalys = typeof window !== "undefined" && window.Tagalys && window.Tagalys.APIConnector && window.tagalysConfig;
      if (hasTagalys) {
        $a9b44c853f7ad42f$var$log("lifecycle", "Tagalys already ready");
        callback(true);
        return;
      } else {
        let elapsed = 0;
        const timer = window.setInterval(() => {
          elapsed += interval;
          const isReady = window.Tagalys && window.Tagalys.APIConnector && window.tagalysConfig;
          if (isReady) {
            window.clearInterval(timer);
            $a9b44c853f7ad42f$var$log("lifecycle", "Tagalys became ready after polling", {
              elapsed: elapsed
            });
            callback(true);
            return;
          }
          if (elapsed >= timeout) {
            window.clearInterval(timer);
            $a9b44c853f7ad42f$var$log("errors", "Timed out waiting for Tagalys readiness", {
              elapsed: elapsed,
              hasTagalys: Boolean(window.Tagalys),
              hasAPIConnector: Boolean(window.Tagalys?.APIConnector),
              hasConfig: Boolean(window.tagalysConfig)
            });
            callback(false);
          }
        }, interval);
      }
    }
    function $a9b44c853f7ad42f$export$c86caf1be068fb8d(price) {
      const locale = typeof Shopify !== "undefined" && Shopify.locale && Shopify.country ? `${Shopify.locale}-${Shopify.country}` : "en-GB";
      const currency = typeof Shopify !== "undefined" && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : "GBP";
      if (!window.tagalysConfig) return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency
      }).format(price);
      const {fractionalDigits: fractionalDigits, forceFractionalDigits: forceFractionalDigits} = window.tagalysConfig.currency;
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: forceFractionalDigits ? fractionalDigits : 0,
        maximumFractionDigits: fractionalDigits
      }).format(price);
    }
    function $a9b44c853f7ad42f$export$806849e86c43de0f(imageSrc, alt, className = "") {
      if (!imageSrc || typeof Shopify === "undefined" || !Shopify.getSizedImage) return `\n      <img\n        src="${imageSrc}"\n        alt="${alt}"\n        class="${className}"\n        loading="lazy"\n        width="400"\n        height="467"\n      />\n    `;
      const sizes = [ 320, 414, 600, 768, 1024, 1280, 1440, 1600, 1920 ];
      const srcset = sizes.map(size => `${Shopify.getSizedImage(imageSrc, size + "x")} ${size}w`).join(", ");
      const sizesAttr = "(min-width: 1024px) 22.5vw, 47.5vw";
      return `\n    <img\n      src="${Shopify.getSizedImage(imageSrc, "400x")}"\n      srcset="${srcset}"\n      sizes="${sizesAttr}"\n      alt="${alt}"\n      class="${className}"\n      loading="lazy"\n      width="400"\n      height="467"\n    />\n  `;
    }
    function $a9b44c853f7ad42f$export$6c49dedf84602800(images, galleryOptions = {}) {
      const {disableCarousel: disableCarousel, disableHoverImage: disableHoverImage} = $a9b44c853f7ad42f$var$normalizeGalleryOptions(galleryOptions);
      if (!images.length) {
        $a9b44c853f7ad42f$var$log("ui", "Product gallery skipped because no images were supplied", {
          disableCarousel: disableCarousel,
          disableHoverImage: disableHoverImage,
          images: images
        });
        return "";
      }
      if (images[0].isPlaceholderSVG) return $a9b44c853f7ad42f$var$getPlaceholderSVG("aspect-[6/7] w-full h-full bg-black-10");
      const imageOne = $a9b44c853f7ad42f$export$806849e86c43de0f(images[0].src, images[0].alt || "Product image", "w-full h-full object-cover object-center z-1");
      const hasHoverImage = !disableHoverImage && images.length > 1 && Boolean(window.MBF?.settings?.toggleHoverImage);
      $a9b44c853f7ad42f$var$log("ui", "Product gallery hover-image decision", {
        imageCount: images.length,
        disableCarousel: disableCarousel,
        disableHoverImage: disableHoverImage,
        toggleHoverImage: Boolean(window.MBF?.settings?.toggleHoverImage),
        hasHoverImage: hasHoverImage,
        reason: $a9b44c853f7ad42f$var$getHoverImageReason({
          imageCount: images.length,
          disableHoverImage: disableHoverImage,
          toggleHoverImage: Boolean(window.MBF?.settings?.toggleHoverImage)
        }),
        firstImage: $a9b44c853f7ad42f$var$summarizeImage(images[0]),
        secondImage: $a9b44c853f7ad42f$var$summarizeImage(images[1])
      });
      if (hasHoverImage) {
        const imageTwo = $a9b44c853f7ad42f$export$806849e86c43de0f(images[1].src, images[1].alt || images[0].alt || "Product image", "image-cover z-2 transition-opacity duration-500 opacity-0 desktop:group-hover:opacity-100 tablet:hidden");
        return `${imageOne}${imageTwo}`;
      }
      return imageOne;
    }
    function $a9b44c853f7ad42f$var$handleize(str) {
      return str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
    }
    function $a9b44c853f7ad42f$var$isEventProduct(product) {
      if (product.metafields?.custom?.event_type == null) return false;
      const eventHandles = window.MBF?.strings?.eventOptionHandles;
      if (!eventHandles) return true;
      const {experience: experience, date: date, time: time} = eventHandles;
      return (product.options || []).some(option => {
        const h = $a9b44c853f7ad42f$var$handleize(option.name || option || "");
        return h === experience || h === date || h === time;
      });
    }
    function $a9b44c853f7ad42f$var$isOnProductPage(productHandle) {
      if (!productHandle) return false;
      const path = window.location.pathname;
      const expectedSuffix = `/products/${productHandle}`;
      return path.endsWith(expectedSuffix);
    }
    function $a9b44c853f7ad42f$export$7215210a376abae6(product, options = {}) {
      if (!product) {
        console.error("Tagalys: Product card skipped - Product data is null or undefined");
        return "";
      }
      let images = product.images || [];
      const placeholderImage = window.tagalysConfig?.settings?.placeholder_image;
      if (images.length === 0) {
        if (placeholderImage) {
          images = [ {
            src: placeholderImage,
            alt: product.title || "Product placeholder"
          } ];
          $a9b44c853f7ad42f$var$log("ui", "Product card using custom fallback placeholder image", {
            product: $a9b44c853f7ad42f$var$summarizeProduct(product),
            placeholderImage: placeholderImage
          });
        } else {
          images = [ {
            isPlaceholderSVG: true
          } ];
          $a9b44c853f7ad42f$var$log("ui", "Product card using Shopify default SVG placeholder", {
            product: $a9b44c853f7ad42f$var$summarizeProduct(product)
          });
        }
      }
      const {class: additionalClasses = "", disableCarousel: disableCarousel = false, toggleQuickAdd: toggleQuickAdd = false, toggleDiscountBadge: toggleDiscountBadge = false, disableHoverImage: disableHoverImage = false, toggleBadges: toggleBadges = window.MBF?.settings?.toggleProductBadges ?? true, badgeLimit: badgeLimit = window.MBF?.settings?.productBadgeLimit ?? 3, mobileBadgeLimit: mobileBadgeLimit = window.MBF?.settings?.productMobileBadgeLimit ?? 1} = options;
      const priceVaries = product.price_varies || product.price_min !== product.price_max;
      const formattedPrice = $a9b44c853f7ad42f$var$trimMoneyZeros($a9b44c853f7ad42f$export$c86caf1be068fb8d(product.price));
      const formattedPriceMin = priceVaries ? $a9b44c853f7ad42f$var$trimMoneyZeros($a9b44c853f7ad42f$export$c86caf1be068fb8d(product.price_min)) : null;
      const variantCount = product.variants?.length || 0;
      const variants = product.variants || [];
      const cheapestVariant = [ ...variants ].sort((a, b) => a.price - b.price)[0];
      const cheapestIsDiscounted = Boolean(cheapestVariant && cheapestVariant.compare_at_price && cheapestVariant.compare_at_price > cheapestVariant.price);
      const formattedCheapestCompare = cheapestIsDiscounted ? $a9b44c853f7ad42f$var$trimMoneyZeros($a9b44c853f7ad42f$export$c86caf1be068fb8d(cheapestVariant.compare_at_price)) : null;
      const metafieldBadge = $a9b44c853f7ad42f$var$extractMetafieldValue(product.metafields?.custom?.price_discount_badge);
      let computedDiscountText = "";
      if (metafieldBadge) computedDiscountText = metafieldBadge; else if (toggleDiscountBadge) {
        if (priceVaries) {
          let maxDiscount = 0;
          let minDiscount = 100;
          let hasDiscount = false;
          for (const v of variants) if (v.compare_at_price && v.compare_at_price > v.price) {
            const pct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
            hasDiscount = true;
            if (pct > maxDiscount) maxDiscount = pct;
            if (pct < minDiscount) minDiscount = pct;
          } else minDiscount = 0;
          if (hasDiscount) {
            const template = maxDiscount === minDiscount ? window.MBF?.strings?.product?.discount?.percentOff || "{{ percentage }}% off" : window.MBF?.strings?.product?.discount?.upToOff || "Up to {{ percentage }}% off";
            computedDiscountText = template.replace("{{ percentage }}", String(maxDiscount));
          }
        } else if (cheapestIsDiscounted) {
          const pct = Math.round((cheapestVariant.compare_at_price - cheapestVariant.price) / cheapestVariant.compare_at_price * 100);
          computedDiscountText = `${(window.MBF?.strings?.product?.save || "Save").trim()} ${pct}%`;
        }
      }
      const showBadge = Boolean(computedDiscountText);
      $a9b44c853f7ad42f$var$log("ui", "Product card render decisions", {
        product: $a9b44c853f7ad42f$var$summarizeProduct(product),
        options: {
          additionalClasses: additionalClasses,
          disableCarousel: disableCarousel,
          disableHoverImage: disableHoverImage,
          toggleQuickAdd: toggleQuickAdd,
          toggleDiscountBadge: toggleDiscountBadge,
          toggleBadges: toggleBadges,
          badgeLimit: badgeLimit,
          mobileBadgeLimit: mobileBadgeLimit
        },
        pricing: {
          priceVaries: Boolean(priceVaries),
          formattedPrice: formattedPrice,
          formattedPriceMin: formattedPriceMin,
          cheapestIsDiscounted: Boolean(cheapestIsDiscounted),
          formattedCheapestCompare: formattedCheapestCompare
        },
        discountBadge: {
          computedDiscountText: computedDiscountText,
          showBadge: Boolean(showBadge),
          hasMetafieldOverride: Boolean(metafieldBadge),
          reason: $a9b44c853f7ad42f$var$getDiscountBadgeReason({
            toggleDiscountBadge: toggleDiscountBadge,
            priceVaries: priceVaries,
            cheapestIsDiscounted: cheapestIsDiscounted,
            metafieldBadge: metafieldBadge
          })
        }
      });
      const discountBadgeMarkup = computedDiscountText ? `<div class="ml-2 tablet:w-full tablet:ml-0 tablet:order-3">\n      <div class="bg-scheme-contrast-background text-scheme-contrast-text text-sm py-[2px] px-1.5 rounded-xs leading-4 tablet:text-xs tablet:w-fit">\n        ${(0, 
      $65zHg.escapeHTML)(computedDiscountText)}\n      </div>\n    </div>` : "";
      const productTitle = (0, $65zHg.escapeHTML)(product.title || "");
      const productUrl = `${window.Shopify?.routes?.root || "/"}products/${product.handle}`;
      const _isEventProduct = $a9b44c853f7ad42f$var$isEventProduct(product);
      const hasMultipleOptions = product.options?.length > 1;
      const onOwnPage = $a9b44c853f7ad42f$var$isOnProductPage(product.handle);
      const canQuickAdd = Boolean(toggleQuickAdd && !onOwnPage && !_isEventProduct && !hasMultipleOptions);
      $a9b44c853f7ad42f$var$log("ui", "Product card quick-add decision", {
        product: $a9b44c853f7ad42f$var$summarizeProduct(product),
        canQuickAdd: canQuickAdd,
        reasons: $a9b44c853f7ad42f$var$getQuickAddReasons({
          toggleQuickAdd: toggleQuickAdd,
          onOwnPage: onOwnPage,
          isEventProduct: _isEventProduct,
          hasMultipleOptions: hasMultipleOptions
        }),
        firstVariantId: product.variants?.[0]?.id || null,
        options: product.options || []
      });
      const compareMarkup = cheapestIsDiscounted ? `<s class="text-scheme-text ml-1 empty:ml-0 empty:hidden">${formattedCheapestCompare}</s>` : "";
      const quickAddIcon = product.available ? $a9b44c853f7ad42f$var$getIconSVG("add-to-basket", "w-4 h-4 aspect-square") : $a9b44c853f7ad42f$var$getIconSVG("email", "w-4 h-4 aspect-square");
      const quickAddLabel = product.available ? (0, $65zHg.escapeHTML)(window.MBF?.strings?.product?.addToCart || "Translation missing: en.product.add_to_cart") : (0, 
      $65zHg.escapeHTML)(window.MBF?.strings?.outOfStock?.notifyShort || "Translation missing: en.product.out_of_stock.notify_short");
      const quickAddMarkup = canQuickAdd ? `<div class="product-card__qs absolute z-2 bottom-0 right-0 text-scheme-links desktop:opacity-0 desktop:pointer-events-none supports-hover:group-hover:opacity-100 transition-opacity supports-hover:group-hover:pointer-events-auto">\n      <ajax-modal data-view="quick-shop" class="no-js:hidden">\n        <a\n          href="${productUrl}"\n          aria-label="${quickAddLabel}"\n          class="flex aria-busy:cursor-wait aria-busy:opacity-50 aria-disabled:pointer-events-none"\n        >\n          <div class="p-2.5 m-3 bg-scheme-background-85 rounded-xs backdrop-blur-2xs tablet:m-2 tablet:p-1">\n            <div class="flex items-center justify-center gap-1.5">\n              <span class="product-card__qs-icon">\n                ${quickAddIcon}\n              </span>\n              <span class="text-sm leading-4 tablet:hidden">\n                ${quickAddLabel}\n              </span>\n            </div>\n          </div>\n        </a>\n      </ajax-modal>\n    </div>` : "";
      const badges = product.metafields?.product_card?.badges?.value || [];
      const soldOutBadgeMarkup = toggleBadges && !product.available ? `<div class="bg-mist text-mulch font-serif text-sm px-2 py-1.5 tracking-n-md leading-md rounded-xs tablet:text-xs">${(0, 
      $65zHg.escapeHTML)(window.MBF?.strings?.soldOut || "Translation missing: en.product.sold_out")}</div>` : "";
      $a9b44c853f7ad42f$var$log("ui", "Product card badge decision", {
        product: $a9b44c853f7ad42f$var$summarizeProduct(product),
        toggleBadges: toggleBadges,
        soldOut: !product.available,
        badgeCount: badges.length,
        badgeLimit: badgeLimit,
        mobileBadgeLimit: mobileBadgeLimit,
        badges: Array.isArray(badges) ? badges.map((badge, index) => ({
          index: index,
          text: badge?.text || "",
          hiddenDesktop: index >= badgeLimit,
          hiddenTablet: index >= mobileBadgeLimit,
          backgroundColour: badge?.background_colour || null,
          textColour: badge?.text_colour || null
        })) : badges
      });
      let badgesMarkup = "";
      if (toggleBadges) {
        if (badges.length > 0) {
          const badgeItems = badges.map((badge, index) => `<div class="font-serif text-sm px-2 py-1.5 tracking-n-md leading-md rounded-xs tablet:text-xs ${index >= badgeLimit ? "hidden" : ""} ${index >= mobileBadgeLimit ? "tablet:hidden" : ""}" style="background-color: ${(0, 
          $65zHg.escapeHTML)(badge.background_colour || "#916C3D")}; color: ${(0, $65zHg.escapeHTML)(badge.text_colour || "#F7F5EC")};">\n              ${(0, 
          $65zHg.escapeHTML)(badge.text || "")}\n            </div>`).join("");
          badgesMarkup = `<div class="pointer-events-none absolute z-20 top-0 left-0 p-3 gap-2 flex flex-wrap tablet:p-2">${soldOutBadgeMarkup}${badgeItems}</div>`;
        } else if (!product.available) badgesMarkup = `<div class="pointer-events-none absolute z-20 top-0 left-0 p-3 gap-2 flex flex-wrap tablet:p-2">${soldOutBadgeMarkup}</div>`;
      }
      const availableVariantsCount = product.variants?.filter(v => v.available).length || 0;
      const showAvailableVariants = variantCount > 1 && availableVariantsCount >= 1 && variantCount !== availableVariantsCount && product.metafields?.custom?.event_type == null;
      const optionsAvailableText = `${availableVariantsCount} ${(0, $65zHg.pluralize)((0, 
      $65zHg.getTranslation)("product.optionsAvailableCount"), availableVariantsCount)}`;
      return `\n    <div class="product-card group relative ${additionalClasses}" data-tagalys-product-id="${product.id}" data-async>\n      <div class="product-card__media relative z-0">\n        <a href="${productUrl}" class="relative block z-1 aspect-9/10 bg-black-10">\n          ${$a9b44c853f7ad42f$export$6c49dedf84602800(images, {
        disableCarousel: disableCarousel,
        disableHoverImage: disableHoverImage
      })}\n        </a>\n        ${badgesMarkup}\n        ${quickAddMarkup}\n      </div>\n\n      <div class="product-card__content">\n        <a href="${productUrl}" class="product-card__meta flex flex-col pt-4 tablet:pt-3.5">\n          <div class="product-card__info">\n            <div class="product-card__title text-scheme-links text-md font-serif leading-md tracking-n-sm tablet:text-base">\n              ${productTitle}\n            </div>\n            <div class="product-card__price text-scheme-links leading-xl tracking-2 mt-1.5 tablet:text-sm">\n              <div class="flex items-center justify-end flex-wrap flex-row-reverse ${discountBadgeMarkup ? "" : "tablet:gap-y-1"}">\n                ${discountBadgeMarkup}\n                ${compareMarkup}\n                <span>\n                  ${priceVaries ? (window.MBF?.strings?.product?.fromPriceHtml || "From {{ price }}").replace("{{ price }}", formattedPriceMin || "") : formattedPrice}\n                </span>\n              </div>\n            </div>\n          </div>\n        </a>\n        <div data-log="availableVariantsCount: ${availableVariantsCount}"></div>\n        ${showAvailableVariants ? `<div class="product-card__variants text-sm leading-xl mt-1.5 text-scheme-text tablet:text-xs">\n          ${optionsAvailableText}\n        </div>\n        ` : ""}\n      </div>\n    </div>\n  `;
    }
    function $a9b44c853f7ad42f$var$trimMoneyZeros(value) {
      return `${value}`.replace(/([.,]00)(?!\d)/, "");
    }
    function $a9b44c853f7ad42f$var$summarizeProduct(product = {}) {
      return {
        id: product.id || null,
        handle: product.handle || null,
        title: product.title || null,
        available: product.available,
        imageCount: product.images?.length || 0,
        variantCount: product.variants?.length || 0
      };
    }
    function $a9b44c853f7ad42f$var$summarizeImage(image = {}) {
      if (!image) return null;
      return {
        src: image.src || null,
        alt: image.alt || null
      };
    }
    function $a9b44c853f7ad42f$var$normalizeGalleryOptions(galleryOptions) {
      if (typeof galleryOptions === "boolean") return {
        disableCarousel: galleryOptions,
        disableHoverImage: false
      };
      return {
        disableCarousel: Boolean(galleryOptions?.disableCarousel),
        disableHoverImage: Boolean(galleryOptions?.disableHoverImage)
      };
    }
    function $a9b44c853f7ad42f$var$getHoverImageReason({imageCount: imageCount, disableHoverImage: disableHoverImage, toggleHoverImage: toggleHoverImage}) {
      if (disableHoverImage) return "disableHoverImage option is true";
      if (imageCount <= 1) return `expected more than 1 image, received ${imageCount}`;
      if (!toggleHoverImage) return "theme setting toggleHoverImage is false";
      return "all hover-image conditions passed";
    }
    function $a9b44c853f7ad42f$var$getDiscountBadgeReason({toggleDiscountBadge: toggleDiscountBadge, priceVaries: priceVaries, cheapestIsDiscounted: cheapestIsDiscounted, metafieldBadge: metafieldBadge}) {
      if (metafieldBadge) return "metafield override (price_discount_badge) is set";
      if (!toggleDiscountBadge) return "discount badge option is disabled for this render";
      if (priceVaries) return "price varies: scanning all variants for max discount";
      if (cheapestIsDiscounted) return "single-variant: cheapest variant is on sale";
      return "cheapest variant is not on sale or compare_at_price is missing/not greater than price";
    }
    function $a9b44c853f7ad42f$var$extractMetafieldValue(metafield) {
      if (metafield == null) return "";
      if (typeof metafield === "string") return metafield.trim();
      if (typeof metafield === "object" && typeof metafield.value === "string") return metafield.value.trim();
      return "";
    }
    function $a9b44c853f7ad42f$var$getQuickAddReasons({toggleQuickAdd: toggleQuickAdd, onOwnPage: onOwnPage, isEventProduct: isEventProduct, hasMultipleOptions: hasMultipleOptions}) {
      const reasons = [];
      if (!toggleQuickAdd) reasons.push("toggleQuickAdd option is false");
      if (onOwnPage) reasons.push("product is on its own page");
      if (isEventProduct) reasons.push("product is an event product");
      if (hasMultipleOptions) reasons.push("product has multiple option groups");
      return reasons.length ? reasons : [ "all quick-add conditions passed" ];
    }
    function $a9b44c853f7ad42f$var$getIconSVG(iconName, className = "") {
      const icons = {
        "add-to-basket": `<svg class="${className}" role="presentation" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n      <path d="M14 6H2l.781 6.248A2 2 0 0 0 4.766 14h6.468a2 2 0 0 0 1.985-1.752L14 6Zm-8.167-.333V3.833a2 2 0 0 1 2-2h.333a2 2 0 0 1 2 2v1.834M8 8v4m0-4v4m2-2H6m4 0H6" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"/>\n    </svg>`,
        email: `<svg class="${className}" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">\n      <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"/>\n      <rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"/>\n    </svg>`
      };
      return icons[iconName] || "";
    }
    function $a9b44c853f7ad42f$var$getPlaceholderSVG(className = "") {
      const liquidSvg = window.tagalysConfig?.settings?.placeholder_svg;
      if (liquidSvg) {
        if (className) return liquidSvg.replace(/class="[^"]*"/, `class="${className}"`);
        return liquidSvg;
      }
      return `<svg class="${className}" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15.89 14.65c-.27-.3-.6-.5-.97-.58v-1.77c.1-.06.21-.12.3-.2.5-.38.66-1.09.38-1.63-.03-.05-.07-.09-.11-.13C15.42 10.15 15 9.17 15 8c0-2.76-2.24-5-5-5S5 5.24 5 8c0 1.17.42 2.15.5 2.34-.04.04-.08.08-.11.13-.28.54-.12 1.25.38 1.63.1.08.2.14.3.2v1.77c-.37.08-.7.28-.97.58-.32.35-.49.8-.49 1.25 0 .04 0 .08.01.12.01.1.03.19.06.28.18.57.73.9 1.31.9h1.3c.58 0 1.13-.33 1.31-.9.03-.09.05-.18.06-.28.01-.04.01-.08.01-.12 0-.45-.17-.9-.49-1.25zm-5.89-9.65c1.65 0 3 1.35 3 3 0 .73-.25 1.4-.67 1.93-.36.46-.39 1.11-.08 1.61.02.03.04.06.06.09-.08.02-.15.05-.21.12-.32.35-.49.8-.49 1.25 0 .04 0 .08.01.12.01.1.03.19.06.28.18.57.73.9 1.31.9h1.3c.58 0 1.13-.33 1.31-.9.03-.09.05-.18.06-.28.01-.04.01-.08.01-.12 0-.45-.17-.9-.49-1.25-.06-.07-.13-.1-.21-.12.02-.03.04-.06.06-.09.31-.5.28-1.15-.08-1.61-.42-.53-.67-1.2-.67-1.93 0-1.65 1.35-3 3-3z" fill="currentColor" opacity="0.1" /></svg>`;
    }
  });
  parcelRegister("cJzMp", function(module, exports) {
    $parcel$export(module.exports, "createLogger", function() {
      return $94557121a748c06f$export$fe2e61603b61130d;
    });
    $parcel$export(module.exports, "serializeError", function() {
      return $94557121a748c06f$export$46ff38bc6bdea8fb;
    });
    $parcel$export(module.exports, "withDebugReason", function() {
      return $94557121a748c06f$export$4ecc6b6d3cd743de;
    });
    const $94557121a748c06f$var$LS_KEY = "mbf_debug";
    const $94557121a748c06f$var$CATEGORIES = [ "lifecycle", "events", "network", "ui", "animation", "errors" ];
    const $94557121a748c06f$var$CATEGORY_STYLES = {
      lifecycle: "color:#6366f1;font-weight:bold",
      events: "color:#10b981;font-weight:bold",
      network: "color:#3b82f6;font-weight:bold",
      ui: "color:#f59e0b;font-weight:bold",
      animation: "color:#ec4899;font-weight:bold",
      errors: "color:#ef4444;font-weight:bold"
    };
    const $94557121a748c06f$var$FILE_STYLE = "color:#94a3b8;font-style:italic";
    const $94557121a748c06f$var$LABEL_STYLE = "color:#475569";
    const $94557121a748c06f$var$BATCH_WINDOW_MS = 120;
    const $94557121a748c06f$var$GROUPED_LOG_RULES = [ {
      file: "tagalys-helpers",
      category: "ui"
    } ];
    const $94557121a748c06f$var$groupedLogBuffers = new Map;
    const $94557121a748c06f$var$groupedLogTimers = new Map;
    function $94557121a748c06f$var$defaultConfig() {
      const categories = {};
      $94557121a748c06f$var$CATEGORIES.forEach(c => categories[c] = true);
      return {
        enabled: false,
        categories: categories,
        files: {}
      };
    }
    function $94557121a748c06f$var$load() {
      try {
        const raw = localStorage.getItem($94557121a748c06f$var$LS_KEY);
        if (!raw) return $94557121a748c06f$var$defaultConfig();
        const parsed = JSON.parse(raw);
        const cfg = $94557121a748c06f$var$defaultConfig();
        cfg.enabled = !!parsed.enabled;
        if (parsed.categories && typeof parsed.categories === "object") Object.keys(cfg.categories).forEach(k => {
          if (k in parsed.categories) cfg.categories[k] = !!parsed.categories[k];
        });
        if (parsed.files && typeof parsed.files === "object") cfg.files = parsed.files;
        return cfg;
      } catch {
        return $94557121a748c06f$var$defaultConfig();
      }
    }
    function $94557121a748c06f$var$save(cfg) {
      try {
        localStorage.setItem($94557121a748c06f$var$LS_KEY, JSON.stringify(cfg));
      } catch {}
    }
    let $94557121a748c06f$var$_config = typeof window !== "undefined" ? $94557121a748c06f$var$load() : {
      enabled: false
    };
    function $94557121a748c06f$var$_emit(filename, category, args) {
      if (!$94557121a748c06f$var$_config.enabled) return;
      if (!$94557121a748c06f$var$_config.categories[category]) return;
      if ($94557121a748c06f$var$_config.files[filename] === false) return;
      if ($94557121a748c06f$var$shouldGroupLog(filename, category)) {
        $94557121a748c06f$var$queueGroupedLog(filename, category, args);
        return;
      }
      const catStyle = $94557121a748c06f$var$CATEGORY_STYLES[category] ?? "color:#64748b;font-weight:bold";
      const prefix = `%c[DEBUG] %c[${category}] %c[${filename}]`;
      if (category === "errors") console.error(prefix, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, ...args); else console.log(prefix, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, ...args);
    }
    function $94557121a748c06f$var$shouldGroupLog(filename, category) {
      return $94557121a748c06f$var$GROUPED_LOG_RULES.some(rule => rule.file === filename && rule.category === category);
    }
    function $94557121a748c06f$var$groupedKey(filename, category) {
      return `${filename}::${category}`;
    }
    function $94557121a748c06f$var$queueGroupedLog(filename, category, args) {
      const key = $94557121a748c06f$var$groupedKey(filename, category);
      const buffer = $94557121a748c06f$var$groupedLogBuffers.get(key) || [];
      buffer.push(args);
      $94557121a748c06f$var$groupedLogBuffers.set(key, buffer);
      if ($94557121a748c06f$var$groupedLogTimers.has(key)) return;
      const timer = setTimeout(() => {
        $94557121a748c06f$var$groupedLogTimers.delete(key);
        $94557121a748c06f$var$flushGroupedLogs(filename, category);
      }, $94557121a748c06f$var$BATCH_WINDOW_MS);
      $94557121a748c06f$var$groupedLogTimers.set(key, timer);
    }
    function $94557121a748c06f$var$flushGroupedLogs(filename, category) {
      const key = $94557121a748c06f$var$groupedKey(filename, category);
      const buffer = $94557121a748c06f$var$groupedLogBuffers.get(key);
      if (!buffer || buffer.length === 0) return;
      $94557121a748c06f$var$groupedLogBuffers.delete(key);
      const catStyle = $94557121a748c06f$var$CATEGORY_STYLES[category] ?? "color:#64748b;font-weight:bold";
      const header = `%c[DEBUG] %c[${category}] %c[${filename}] %c(${buffer.length} logs batched)`;
      console.groupCollapsed(header, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, "color:#64748b");
      buffer.forEach(entryArgs => {
        console.log(...entryArgs);
      });
      console.groupEnd();
    }
    function $94557121a748c06f$var$createRealLogger(filename) {
      return function log(category, ...args) {
        $94557121a748c06f$var$_emit(filename, category, args);
      };
    }
    const $94557121a748c06f$export$fe2e61603b61130d = () => () => {};
    function $94557121a748c06f$export$46ff38bc6bdea8fb(error) {
      if (error instanceof Error) return {
        name: error.name,
        message: error.message,
        stack: error.stack
      };
      return {
        value: error
      };
    }
    function $94557121a748c06f$export$4ecc6b6d3cd743de(reason, details = {}) {
      return {
        reason: reason,
        ...details
      };
    }
    const $94557121a748c06f$export$282d649a8a633ddc = {
      start() {
        $94557121a748c06f$var$_config.enabled = true;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log("%c[DEBUG] Logging enabled. Reload the page for full coverage.", "color:#10b981;font-weight:bold");
        this.status();
      },
      stop() {
        $94557121a748c06f$var$_config.enabled = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log("%c[DEBUG] Logging disabled.", "color:#ef4444;font-weight:bold");
      },
      enable(category) {
        if (!$94557121a748c06f$var$CATEGORIES.includes(category)) {
          console.warn(`[DEBUG] Unknown category "${category}". Available: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`);
          return;
        }
        $94557121a748c06f$var$_config.categories[category] = true;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] Category "${category}" enabled.`, "color:#10b981");
      },
      disable(category) {
        if (!$94557121a748c06f$var$CATEGORIES.includes(category)) {
          console.warn(`[DEBUG] Unknown category "${category}". Available: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`);
          return;
        }
        $94557121a748c06f$var$_config.categories[category] = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] Category "${category}" disabled.`, "color:#f59e0b");
      },
      enableFile(file) {
        delete $94557121a748c06f$var$_config.files[file];
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] File "${file}" re-enabled.`, "color:#10b981");
      },
      disableFile(file) {
        $94557121a748c06f$var$_config.files[file] = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] File "${file}" disabled.`, "color:#f59e0b");
      },
      status() {
        const categoryRows = $94557121a748c06f$var$CATEGORIES.map(c => ({
          category: c,
          enabled: $94557121a748c06f$var$_config.categories[c] ? "✅" : "❌"
        }));
        const fileRows = Object.entries($94557121a748c06f$var$_config.files).map(([f, v]) => ({
          file: f,
          enabled: v ? "✅" : "❌"
        }));
        console.group("%c[DEBUG] Status", "color:#6366f1;font-weight:bold");
        console.log("Logging:", $94557121a748c06f$var$_config.enabled ? "%c enabled" : "%c disabled", $94557121a748c06f$var$_config.enabled ? "color:#10b981;font-weight:bold" : "color:#ef4444;font-weight:bold");
        console.log("localStorage key:", $94557121a748c06f$var$LS_KEY);
        console.table(categoryRows);
        if (fileRows.length) {
          console.log("File overrides:");
          console.table(fileRows);
        } else console.log("File overrides: none (all files active)");
        console.groupEnd();
      },
      reset() {
        localStorage.removeItem($94557121a748c06f$var$LS_KEY);
        $94557121a748c06f$var$_config = $94557121a748c06f$var$defaultConfig();
        console.log("%c[DEBUG] Settings cleared from localStorage.", "color:#f59e0b;font-weight:bold");
      },
      help() {
        console.group("%c[DEBUG] Available commands", "color:#6366f1;font-weight:bold");
        console.log([ "__debug.start()               — enable all logging", "__debug.stop()                — disable all logging", "__debug.status()              — show current config", '__debug.enable("category")    — enable a category', '__debug.disable("category")   — disable a category', `__debug.enable("…")           — categories: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`, '__debug.enableFile("file")    — un-exclude a file', '__debug.disableFile("file")   — exclude a file from output', "__debug.reset()               — clear all settings from localStorage", "__debug.help()                — show this help" ].join("\n"));
        console.groupEnd();
      }
    };
  });
  parcelRegister("65zHg", function(module, exports) {
    $parcel$export(module.exports, "getTranslation", function() {
      return $0124e2aec3ae0b2d$export$202e99f82f7f0395;
    });
    $parcel$export(module.exports, "pluralize", function() {
      return $0124e2aec3ae0b2d$export$cefb40c9962541b5;
    });
    $parcel$export(module.exports, "interpolate", function() {
      return $0124e2aec3ae0b2d$export$89e29e4ab65e70a9;
    });
    $parcel$export(module.exports, "escapeHTML", function() {
      return $0124e2aec3ae0b2d$export$5dd27816c66fb702;
    });
    $parcel$export(module.exports, "resolveQuery", function() {
      return $0124e2aec3ae0b2d$export$55c0b4ad64fcd6;
    });
    $parcel$export(module.exports, "getValidFilters", function() {
      return $0124e2aec3ae0b2d$export$f88ba4b7479d6747;
    });
    $parcel$export(module.exports, "shouldShowFilters", function() {
      return $0124e2aec3ae0b2d$export$b3e6c7ce956f2053;
    });
    $parcel$export(module.exports, "handleRedirect", function() {
      return $0124e2aec3ae0b2d$export$733e9c9bfa11b30e;
    });
    var $cJzMp = parcelRequire("cJzMp");
    const $0124e2aec3ae0b2d$var$log = (0, $cJzMp.createLogger)("state-utils");
    function $0124e2aec3ae0b2d$export$202e99f82f7f0395(path, fallback) {
      const mbfValue = path.split(".").reduce((acc, key) => acc?.[key], window.MBF?.strings);
      if (mbfValue != null) return mbfValue;
      if (typeof fallback === "object" && fallback !== null) return fallback;
      return fallback === "Missing translation" ? `Translation missing: en.${path}` : fallback ?? `Translation missing: en.${path}`;
    }
    function $0124e2aec3ae0b2d$export$cefb40c9962541b5(forms, count) {
      if (typeof forms === "string") return forms;
      const key = count === 1 ? "one" : "other";
      return forms?.[key] ?? forms?.other ?? "";
    }
    function $0124e2aec3ae0b2d$export$89e29e4ab65e70a9(template, replacements = {}) {
      if (!template) return "";
      const normalizedTemplate = `${template}`.replaceAll("&#39;", "'").replaceAll("&#x27;", "'").replaceAll("&quot;", '"');
      return Object.entries(replacements).reduce((acc, [key, value]) => {
        const safeValue = `${value ?? ""}`;
        return acc.replaceAll(`{{ ${key} }}`, safeValue).replaceAll(`{{${key}}}`, safeValue).replaceAll(`__${key}__`, safeValue).replaceAll(`**${key}**`, safeValue);
      }, normalizedTemplate);
    }
    function $0124e2aec3ae0b2d$export$5dd27816c66fb702(value) {
      return `${value ?? ""}`.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    }
    function $0124e2aec3ae0b2d$export$55c0b4ad64fcd6(helpers, query) {
      const urlQuery = new URLSearchParams(window.location.search).get("q");
      return query || helpers?.getQuery?.() || urlQuery || "";
    }
    function $0124e2aec3ae0b2d$export$f88ba4b7479d6747(response) {
      if (!response || !Array.isArray(response.filters)) return [];
      return response.filters.filter(filter => Array.isArray(filter.items) && filter.items.length > 0);
    }
    function $0124e2aec3ae0b2d$export$b3e6c7ce956f2053(component, response) {
      if (component.currentTab !== "products") return false;
      if (!component.query) return false;
      const hasProductResults = response && Array.isArray(response.products) && response.products.length > 0 && (response.total_count ?? 0) > 0;
      if (!hasProductResults) return false;
      const filtersToValidate = component.initialFilters || response?.filters || [];
      const validFilters = $0124e2aec3ae0b2d$export$f88ba4b7479d6747({
        filters: filtersToValidate
      });
      const hasSortOptions = response && Array.isArray(response.sort_options) && response.sort_options.length > 0;
      return validFilters.length > 0 || hasSortOptions;
    }
    function $0124e2aec3ae0b2d$var$buildRedirectTarget(url) {
      const parser = document.createElement("a");
      parser.href = url;
      return (window.Shopify?.routes?.root || "/") + parser.pathname.replace(/^\//, "");
    }
    function $0124e2aec3ae0b2d$export$733e9c9bfa11b30e(helpers, response = null) {
      const helpersRedirected = Boolean(helpers && typeof helpers.isRedirected === "function" && helpers.isRedirected());
      const responseRedirectUrl = response?.redirect_url || null;
      $0124e2aec3ae0b2d$var$log("network", "handleRedirect:eval", {
        hasHelpers: Boolean(helpers),
        helpersRedirected: helpersRedirected,
        hasResponseRedirectUrl: Boolean(responseRedirectUrl),
        responseRedirectUrl: responseRedirectUrl
      });
      if (helpersRedirected) {
        const target = $0124e2aec3ae0b2d$var$buildRedirectTarget(helpers.getRedirectURL());
        $0124e2aec3ae0b2d$var$log("network", "handleRedirect:fire", {
          source: "helpers",
          target: target
        });
        location.replace(target);
        return true;
      }
      if (responseRedirectUrl) {
        const target = $0124e2aec3ae0b2d$var$buildRedirectTarget(responseRedirectUrl);
        $0124e2aec3ae0b2d$var$log("network", "handleRedirect:fire", {
          source: "response",
          target: target
        });
        location.replace(target);
        return true;
      }
      return false;
    }
  });
  var $ezkA5 = parcelRequire("ezkA5");
  var $cJzMp = parcelRequire("cJzMp");
  function $0372cd753f90ca4c$export$2e2bcd8739ae039(function_, wait = 100, options = {}) {
    if (typeof function_ !== "function") throw new TypeError(`Expected the first parameter to be a function, got \`${typeof function_}\`.`);
    if (wait < 0) throw new RangeError("`wait` must not be negative.");
    if (typeof options === "boolean") throw new TypeError("The `options` parameter must be an object, not a boolean. Use `{immediate: true}` instead.");
    const {immediate: immediate} = options;
    let storedContext;
    let storedArguments;
    let timeoutId;
    let timestamp;
    let result;
    function run() {
      const callContext = storedContext;
      const callArguments = storedArguments;
      storedContext = undefined;
      storedArguments = undefined;
      result = function_.apply(callContext, callArguments);
      return result;
    }
    function later() {
      const last = Date.now() - timestamp;
      if (last < wait && last >= 0) timeoutId = setTimeout(later, wait - last); else {
        timeoutId = undefined;
        if (!immediate) result = run();
      }
    }
    const debounced = function(...arguments_) {
      if (storedContext && this !== storedContext && Object.getPrototypeOf(this) === Object.getPrototypeOf(storedContext)) throw new Error("Debounced method called with different contexts of the same prototype.");
      storedContext = this;
      storedArguments = arguments_;
      timestamp = Date.now();
      const callNow = immediate && !timeoutId;
      if (!timeoutId) timeoutId = setTimeout(later, wait);
      if (callNow) {
        result = run();
        return result;
      }
      return undefined;
    };
    Object.defineProperty(debounced, "isPending", {
      get() {
        return timeoutId !== undefined;
      }
    });
    debounced.clear = () => {
      if (!timeoutId) return;
      clearTimeout(timeoutId);
      timeoutId = undefined;
      storedContext = undefined;
      storedArguments = undefined;
    };
    debounced.flush = () => {
      if (!timeoutId) return;
      debounced.trigger();
    };
    debounced.trigger = () => {
      result = run();
      debounced.clear();
    };
    return debounced;
  }
  class $ba68070817621cff$var$TagalysPredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.log = (0, $cJzMp.createLogger)("tagalys-predictive-search");
      this.query = this.dataset.query || "";
      this.tagalysEnabled = this.dataset.tagalysEnabled === "true";
      this.resultLimit = Number(this.dataset.resultLimit || 4);
      this.suggestionLimit = 6;
      this.contentLimit = 4;
      this.details = this.querySelector("details");
      this.form = this.querySelector("[data-search-form]");
      this.input = this.querySelector("[data-search-input]");
      this.clearButton = this.querySelector("[data-clear-search]");
      this.submitButton = this.querySelector("[data-search-submit]");
      this.summaryToggle = this.querySelector("[data-predictive-search-toggle]");
      this.primaryHeading = this.querySelector("[data-primary-heading]");
      this.primaryList = this.querySelector("[data-primary-list]");
      this.primaryGroup = this.querySelector("[data-primary-group]");
      this.secondaryHeading = this.querySelector("[data-secondary-heading]");
      this.secondaryList = this.querySelector("[data-secondary-list]");
      this.secondaryGroup = this.querySelector("[data-secondary-group]");
      this.predictiveSearchProducts = this.querySelector("[data-product-list]");
      this.productGroup = this.querySelector("[data-product-group]");
      this.predictiveSearchSuggestions = this.querySelector("[data-predictive-results]");
      this.searchStrings = window.MBF?.strings?.search || {};
      this.noResults = this.dataset.noResultsLabel || this.searchStrings.noResults || "Translation missing: en.search.no_results";
      this.tryTheseInstead = this.searchStrings.tryTheseInstead || "Translation missing: en.search.try_these_instead";
      this.defaultPrimaryHeading = this.dataset.defaultPrimaryHeading || this.primaryHeading?.textContent?.trim() || "Translation missing: en.search.popular_suggestions";
      this.typingPrimaryHeading = this.dataset.typingPrimaryHeading || "Collections";
      this.defaultSecondaryHeading = this.dataset.defaultSecondaryHeading || this.secondaryHeading?.textContent?.trim() || "Translation missing: en.search.useful_pages";
      this.typingSecondaryHeading = this.dataset.typingSecondaryHeading || "Translation missing: en.search.articles_pages";
      this.initialPrimaryListHtml = this.primaryList?.innerHTML || "";
      this.initialSecondaryListHtml = this.secondaryList?.innerHTML || "";
      this.initialProductsHtml = this.predictiveSearchProducts?.innerHTML || "";
      this.searchInstance = null;
      this.isInitialized = false;
      this.loadingProducts = false;
      this.redirectUrl = null;
      this.handleDetailsToggle = this.handleDetailsToggle.bind(this);
      this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
      this.handleClear = this.handleClear.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.onInputChange = (0, $0372cd753f90ca4c$export$2e2bcd8739ae039)(() => this.onChange(), 300).bind(this);
      this.setState("closed");
    }
    connectedCallback() {
      this.log("lifecycle", "connected", {
        tagalysEnabled: this.tagalysEnabled,
        initialQuery: this.query,
        resultLimit: this.resultLimit,
        suggestionLimit: this.suggestionLimit,
        contentLimit: this.contentLimit,
        suggestionsWidget: this.dataset.suggestionsWidget || null,
        hasDetails: Boolean(this.details),
        hasInput: Boolean(this.input),
        hasProductsContainer: Boolean(this.predictiveSearchProducts)
      });
      if (this.details) this.details.addEventListener("toggle", this.handleDetailsToggle);
      if (this.input) {
        this.input.addEventListener("input", this.onInputChange);
        this.input.value = this.query;
      }
      if (this.clearButton) this.clearButton.addEventListener("click", this.handleClear);
      if (this.form) this.form.addEventListener("submit", this.handleFormSubmit);
      this.addEventListener("click", this.handleSuggestionClick);
      if (this.tagalysEnabled) (0, $ezkA5.onTagalysReady)(isReady => {
        this.log(isReady ? "lifecycle" : "errors", "Tagalys readiness callback returned", {
          isReady: isReady
        });
        if (!isReady) {
          this.setDegraded();
          return;
        }
        this.initializeTagalys();
      });
    }
    disconnectedCallback() {
      if (this.details) this.details.removeEventListener("toggle", this.handleDetailsToggle);
      if (this.input) this.input.removeEventListener("input", this.onInputChange);
      if (this.clearButton) this.clearButton.removeEventListener("click", this.handleClear);
      if (this.form) this.form.removeEventListener("submit", this.handleFormSubmit);
      this.removeEventListener("click", this.handleSuggestionClick);
    }
    setState(state) {
      this.log("lifecycle", "state change", {
        previousState: this.dataset.state || null,
        nextState: state,
        query: this.query
      });
      this.dataset.state = state;
      this.dispatchSearchState();
    }
    setHasResults(hasResults) {
      this.log("ui", "has-results flag updated", {
        hasResults: hasResults
      });
      this.dataset.hasResults = hasResults ? "true" : "false";
    }
    setDegraded() {
      this.log("errors", "Entering degraded predictive-search state", {
        tagalysEnabled: this.tagalysEnabled,
        isInitialized: this.isInitialized,
        hasSearchInstance: Boolean(this.searchInstance)
      });
      this.setState("degraded");
    }
    show() {
      if (this.predictiveSearchSuggestions) this.predictiveSearchSuggestions.style.opacity = "1";
    }
    dispatchSearchState() {
      this.dispatchEvent(new CustomEvent("predictive-search:state-change", {
        bubbles: true,
        detail: {
          state: this.dataset.state,
          isOpen: Boolean(this.details?.open)
        }
      }));
    }
    syncToggleState() {
      const isOpen = Boolean(this.details?.open);
      this.summaryToggle?.classList.toggle("is-active", isOpen);
    }
    handleDetailsToggle() {
      if (!this.details) return;
      this.syncToggleState();
      this.log("events", "details toggled", {
        open: this.details.open,
        currentInput: this.input?.value || ""
      });
      if (!this.details.open) {
        if (this.input) this.input.value = "";
        this.query = "";
        this.setState("closed");
        this.setHasResults(false);
        this.toggleActionButtons();
        return;
      }
      if (this.input) this.input.value = "";
      this.query = "";
      this.input?.focus();
      this.show();
      this.resetToIdle();
      this.loadSuggestedProducts();
      document.querySelectorAll("details[open]").forEach(detail => {
        if (detail !== this.details) detail.removeAttribute("open");
      });
    }
    handleSuggestionClick(event) {
      const suggestionLink = event.target.closest("[data-suggestion]");
      if (!suggestionLink) return;
      event.preventDefault();
      const suggestionText = suggestionLink.textContent.trim();
      if (!this.input || !suggestionText) return;
      this.log("events", "suggestion clicked", {
        suggestionText: suggestionText
      });
      this.input.value = suggestionText;
      this.query = suggestionText;
      this.onChange();
    }
    handleClear(event) {
      event.preventDefault();
      if (!this.input) return;
      this.log("events", "clear clicked", {
        previousQuery: this.query
      });
      this.input.value = "";
      this.query = "";
      this.redirectUrl = null;
      this.resetToIdle();
      this.show();
      this.input.focus();
    }
    handleFormSubmit(event) {
      if (!this.redirectUrl) return;
      event.preventDefault();
      this.log("events", "form submit intercepted for redirect", {
        redirectUrl: this.redirectUrl
      });
      const parser = document.createElement("a");
      parser.href = this.redirectUrl;
      const root = window.Shopify?.routes?.root || "/";
      window.location.replace(root + parser.pathname.replace(/^\//, ""));
    }
    initializeTagalys() {
      if (this.isInitialized || !this.tagalysEnabled || !window.Tagalys?.APIConnector?.SearchSuggestions) {
        this.log("lifecycle", "SearchSuggestions initialization skipped", {
          isInitialized: this.isInitialized,
          tagalysEnabled: this.tagalysEnabled,
          hasSearchSuggestions: Boolean(window.Tagalys?.APIConnector?.SearchSuggestions)
        });
        return;
      }
      this.log("lifecycle", "Initializing Tagalys SearchSuggestions connector", {
        initialQuery: this.query,
        resultLimit: this.resultLimit,
        suggestionLimit: this.suggestionLimit,
        contentLimit: this.contentLimit
      });
      this.searchInstance = window.Tagalys.APIConnector.SearchSuggestions.new({
        params: {
          query: this.query,
          sections: {
            products: {
              count: this.resultLimit,
              include: [ "total_count", "items" ]
            },
            collections: {
              count: this.suggestionLimit
            },
            pages: {
              count: this.contentLimit
            }
          }
        },
        onSuccess: (response, helpers) => {
          this.redirectUrl = response?.redirect_url || null;
          this.renderSearchResults(response);
        },
        onFailure: response => {
          this.log("errors", "Tagalys SearchSuggestions failed", response);
          console.warn("Tagalys search suggestions failed:", response);
          this.setDegraded();
          this.show();
        }
      });
      this.isInitialized = true;
    }
    loadSuggestedProducts() {
      if (this.loadingProducts || !this.tagalysEnabled) {
        this.log("lifecycle", "Suggested products request skipped", {
          loadingProducts: this.loadingProducts,
          tagalysEnabled: this.tagalysEnabled
        });
        return;
      }
      this.loadingProducts = true;
      const suggestionsWidgetId = this.dataset.suggestionsWidget;
      if (!suggestionsWidgetId) {
        this.log("ui", "Suggested products request skipped because no widget id is configured");
        this.loadingProducts = false;
        this.show();
        return;
      }
      this.log("network", "Requesting Tagalys recommended products", {
        recommendationId: suggestionsWidgetId,
        count: this.resultLimit
      });
      (0, $ezkA5.onTagalysReady)(isReady => {
        if (!isReady || !window.Tagalys?.APIConnector?.Recommendations?.call) {
          this.log("errors", "Recommendations connector unavailable", {
            isReady: isReady,
            hasRecommendationsCall: Boolean(window.Tagalys?.APIConnector?.Recommendations?.call)
          });
          this.loadingProducts = false;
          this.setDegraded();
          this.show();
          return;
        }
        window.Tagalys.APIConnector.Recommendations.call({
          params: {
            recommendationId: suggestionsWidgetId,
            count: this.resultLimit
          },
          onSuccess: response => {
            this.renderSuggestedProducts(response);
            this.loadingProducts = false;
          },
          onFailure: failureResponse => {
            this.log("errors", "Tagalys recommendations failed", failureResponse);
            console.warn("Tagalys recommendations failed:", failureResponse);
            this.loadingProducts = false;
            this.setDegraded();
            this.show();
          }
        });
      });
    }
    renderSuggestedProducts(response) {
      if (!this.predictiveSearchProducts) return;
      const products = response.products || [];
      if (products.length > 0) this.predictiveSearchProducts.innerHTML = products.map(product => (0, 
      $ezkA5.createProductCardHTML)(product, {
        context: "predictive-search",
        disableCarousel: true,
        disableHoverImage: false,
        toggleQuickAdd: true,
        toggleDiscountBadge: true,
        toggleBadges: true,
        badgeLimit: 3,
        mobileBadgeLimit: 1
      }) || "").join(""); else this.predictiveSearchProducts.innerHTML = this.initialProductsHtml;
      this.updateGroupVisibility({
        hasPrimary: this.primaryList?.querySelector("li") != null,
        hasSecondary: this.secondaryList?.querySelector("li") != null,
        hasProducts: products.length > 0 || this.initialProductsHtml !== ""
      });
      this.show();
    }
    resetToIdle() {
      this.log("ui", "Resetting predictive search to idle content");
      this.setState("open-idle");
      this.setHasResults(false);
      this.toggleActionButtons();
      this.redirectUrl = null;
      if (this.primaryHeading) this.primaryHeading.textContent = this.defaultPrimaryHeading;
      if (this.secondaryHeading) this.secondaryHeading.textContent = this.defaultSecondaryHeading;
      if (this.primaryList) this.primaryList.innerHTML = this.initialPrimaryListHtml;
      if (this.secondaryList) this.secondaryList.innerHTML = this.initialSecondaryListHtml;
      if (this.predictiveSearchProducts) this.predictiveSearchProducts.innerHTML = this.initialProductsHtml;
      this.updateGroupVisibility({
        hasPrimary: this.primaryList?.querySelector("li") != null,
        hasSecondary: this.secondaryList?.querySelector("li") != null,
        hasProducts: this.predictiveSearchProducts?.children.length > 0
      });
    }
    onChange() {
      const searchTerm = this.input?.value.trim() || "";
      this.query = searchTerm;
      this.redirectUrl = null;
      this.toggleActionButtons();
      this.log("events", "input changed", {
        searchTerm: searchTerm,
        hasSearchTerm: Boolean(searchTerm.length),
        tagalysEnabled: this.tagalysEnabled,
        isInitialized: this.isInitialized,
        canUpdateQuery: Boolean(this.searchInstance?.helpers?.updateQuery)
      });
      if (!searchTerm.length) {
        this.resetToIdle();
        this.show();
        return;
      }
      this.setState("typing");
      if (!this.tagalysEnabled) {
        this.log("lifecycle", "Input change did not query Tagalys because Tagalys is disabled");
        this.show();
        return;
      }
      if (!this.isInitialized || !this.searchInstance?.helpers?.updateQuery) {
        this.log("errors", "Input change cannot update Tagalys query", {
          isInitialized: this.isInitialized,
          hasUpdateQuery: Boolean(this.searchInstance?.helpers?.updateQuery)
        });
        this.setDegraded();
        this.show();
        return;
      }
      this.log("network", "Updating Tagalys query", {
        searchTerm: searchTerm
      });
      this.searchInstance.helpers.updateQuery(searchTerm);
    }
    toggleActionButtons() {
      if (!this.input) return;
      const hasQuery = Boolean(this.input.value.trim());
      this.clearButton?.classList.toggle("hidden", !hasQuery);
      this.submitButton?.classList.toggle("hidden", !hasQuery);
    }
    updateGroupVisibility({hasPrimary: hasPrimary, hasSecondary: hasSecondary, hasProducts: hasProducts}) {
      this.log("ui", "Updating predictive-search group visibility", {
        hasPrimary: hasPrimary,
        hasSecondary: hasSecondary,
        hasProducts: hasProducts
      });
      this.primaryGroup?.classList.toggle("hidden", !hasPrimary);
      this.secondaryGroup?.classList.toggle("hidden", !hasSecondary);
      this.productGroup?.classList.toggle("hidden", !hasProducts);
    }
    generateListHtml(items, limit, isPrimary = false) {
      const baseUrl = window.Shopify?.routes?.root || "/";
      return items.slice(0, limit).map(item => {
        const url = isPrimary ? `${baseUrl}search?q=${encodeURIComponent(item.title || "")}` : this.escapeHtml(item.link || "#");
        const dataAttr = isPrimary ? "data-suggestion" : "";
        return `<li role="option" aria-selected="false">\n          <a href="${url}" ${dataAttr}>${this.escapeHtml(item.title || "")}</a>\n        </li>`;
      }).join("");
    }
    renderPrimary(collectionItems) {
      if (!this.primaryList) return;
      if (this.primaryHeading) this.primaryHeading.textContent = this.typingPrimaryHeading;
      if (collectionItems.length > 0) this.primaryList.innerHTML = this.generateListHtml(collectionItems, this.suggestionLimit, false); else this.primaryList.innerHTML = "";
    }
    renderSecondary(contentItems) {
      if (!this.secondaryList) return;
      if (this.secondaryHeading) this.secondaryHeading.textContent = this.typingSecondaryHeading;
      if (contentItems.length > 0) this.secondaryList.innerHTML = this.generateListHtml(contentItems, this.contentLimit, false); else this.secondaryList.innerHTML = "";
    }
    renderProducts(productItems) {
      if (!this.predictiveSearchProducts) return;
      if (productItems.length > 0) this.predictiveSearchProducts.innerHTML = productItems.map(product => (0, 
      $ezkA5.createProductCardHTML)(product, {
        context: "predictive-search",
        disableCarousel: true,
        disableHoverImage: false,
        toggleQuickAdd: true,
        toggleDiscountBadge: true,
        toggleBadges: true,
        badgeLimit: 3,
        mobileBadgeLimit: 1
      }) || "").join(""); else this.predictiveSearchProducts.innerHTML = `<div class="col-span-full py-8" data-no-results>${this.noResults.replace("__terms__", this.query)}</div>`;
    }
    renderSearchResults(response) {
      const sections = response.sections || {};
      const productItems = sections.products?.items || [];
      const collectionItems = sections.collections?.items || [];
      const contentItems = this.getArticleAndPageItems(sections);
      this.log("ui", "Rendering typed search results", {
        query: this.query,
        productCount: productItems.length,
        collectionCount: collectionItems.length,
        contentCount: contentItems.length,
        productTotalCount: sections.products?.total_count || null
      });
      this.renderPrimary(collectionItems);
      this.renderSecondary(contentItems);
      this.renderProducts(productItems);
      const hasProducts = productItems.length > 0 || this.predictiveSearchProducts?.querySelector("[data-no-results]") != null;
      this.updateGroupVisibility({
        hasPrimary: collectionItems.length > 0,
        hasSecondary: contentItems.length > 0,
        hasProducts: hasProducts
      });
      const hasAnyRealResults = Boolean(productItems.length || collectionItems.length || contentItems.length);
      this.setHasResults(hasAnyRealResults);
      this.setState("typing");
      this.show();
    }
    getArticleAndPageItems(sections) {
      const rawItems = [ ...sections.pages?.items || [], ...sections.articles?.items || [], ...sections.content?.items || [], ...sections.pages_and_articles?.items || [] ];
      const seen = new Set;
      const items = [];
      rawItems.forEach(item => {
        const title = item.title || item.name || "";
        const link = item.link || item.url || "";
        const key = `${title}::${link}`;
        if (!title || !link || seen.has(key)) return;
        seen.add(key);
        items.push({
          title: title,
          link: link
        });
      });
      this.log("ui", "Normalized article/page suggestions", {
        rawCount: rawItems.length,
        normalizedCount: items.length
      });
      return items;
    }
    escapeHtml(value) {
      const str = `${value}`;
      return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    }
    highlightQuery(text, query = this.query) {
      if (!query) return text;
      const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi");
      return text.replace(regex, '<span class="text-scheme-links">$1</span>');
    }
  }
  if (!customElements.get("tagalys-predictive-search")) customElements.define("tagalys-predictive-search", $ba68070817621cff$var$TagalysPredictiveSearch);
})();